(function () {
  var modal = document.getElementById('sxProjectModal');
  if (!modal) return;

  var titleEl = document.getElementById('sxModalTitle');
  var textEl = document.getElementById('sxModalText');
  var whatBox = modal.querySelector('[data-fact="what"]');
  var whereBox = modal.querySelector('[data-fact="where"]');
  var whyBox = modal.querySelector('[data-fact="why"]');
  var whatEl = document.getElementById('sxModalWhat');
  var whereEl = document.getElementById('sxModalWhere');
  var whyEl = document.getElementById('sxModalWhy');
  var imgEl = document.getElementById('sxModalImage');
  var mediaWrap = document.getElementById('sxModalMediaWrap');
  var readMoreEl = document.getElementById('sxModalReadMore');

  var lastFocus = null;

  function setFact(box, el, value) {
    if (value && value.trim()) {
      el.textContent = value;
      box.hidden = false;
    } else {
      el.textContent = '';
      box.hidden = true;
    }
  }

  function openModal(button) {
    lastFocus = document.activeElement;
    var d = button.dataset;

    titleEl.textContent = d.modalTitle || '';
    textEl.innerHTML = d.modalText || '';

    setFact(whatBox, whatEl, d.modalWhat || '');
    setFact(whereBox, whereEl, d.modalWhere || '');
    setFact(whyBox, whyEl, d.modalWhy || '');

    if (d.modalImage) {
      imgEl.src = d.modalImage;
      imgEl.alt = d.modalTitle || '';
      mediaWrap.hidden = false;
    } else {
      imgEl.removeAttribute('src');
      imgEl.alt = '';
      mediaWrap.hidden = true;
    }

    if (d.modalLink) {
      readMoreEl.href = d.modalLink;
      if (d.modalLinkLabel) readMoreEl.textContent = d.modalLinkLabel;
      readMoreEl.hidden = false;
    } else {
      readMoreEl.removeAttribute('href');
      readMoreEl.hidden = true;
    }

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sx-modal-open');

    var focusable = modal.querySelector('.sx-modal__close');
    if (focusable) focusable.focus();
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sx-modal-open');
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('.js-sx-modal-open');
    if (opener) {
      e.preventDefault();
      openModal(opener);
      return;
    }
    if (e.target.closest('[data-modal-close]')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });
})();
